import { BlogSection } from "@/types/blog";

export const fazit: BlogSection = {
  id: "fazit",
  title: "Körperintelligenz ist keine Schwäche",
  content: `
    <p>Körperintelligenz ist keine Schwäche, die wir überwinden müssen, sondern eine Stärke, die wir wiederentdecken dürfen. Sie erinnert uns daran, dass wir keine Maschinen sind, die durchoptimiert werden müssen, sondern lebendige Systeme, die in Wellen denken, fühlen und regenerieren.</p>
    
    <p>Und manchmal ist das klügste, was wir tun können: Nichts tun und dem Körper vertrauen, dass er weiß, was er tut.</p>
  `
};
